import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const storyPageViewPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read], subject: Models.StoryPageView },
    { actions: [Actions.read], subject: Models.StoryPageViews },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read], subject: Models.StoryPageView },
    { actions: [Actions.read], subject: Models.StoryPageViews },
  ],

  [UserRole.OperatorWithoutPBAccess]: [],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.StoryPageView },
    { actions: [Actions.read], subject: Models.StoryPageViews },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
